import { FC, ReactNode } from 'react'
import i18n from 'i18next'
import { I18nextProvider, initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { Memo } from '@/hoc/Memo'

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: {
      'en-GB': ['en-GB'],
      'it-IT': ['it-IT'],
      'ru-RU': ['ru-RU'],
      'de-DE': ['de-DE'],
      'es-ES': ['es-ES'],
      'fr-FR': ['fr-FR'],
      default: ['en-GB'],
    },

    // debug: true,

    interpolation: {
      escapeValue: false,
    },

    react: {
      // bindI18n: 'languageChanged',
      // bindI18nStore: '',
      // transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
      useSuspense: false,
    },

    // load: 'languageOnly',
    // nonExplicitSupportedLngs: true,

    // fallbackNS: 'translation',
    // defaultNS: 'translation',
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'lang',
    },
  })

interface I18nProviderSchema {
  children: ReactNode
}

export const I18nProvider: FC<I18nProviderSchema> = Memo(
  ({ children }: I18nProviderSchema) => {
    return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
  },
)
